var _path, _path2, _path3, _path4, _path5, _path6, _path7, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.8 31.267"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.8 0a.789.789 0 0 0-.8.8v26.5a.789.789 0 0 0 .8.8H22a.789.789 0 0 0 .8-.8V9.1a2.106 2.106 0 0 0-.5-1.3L15 .5a2.106 2.106 0 0 0-1.3-.5H.8Z",
  fill: "gray"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.4.5C1 .5.7.8.6 1.3V27a.789.789 0 0 0 .8.8h20.3a.789.789 0 0 0 .8-.8V9.2a2.106 2.106 0 0 0-.5-1.3L15.1 1a2.106 2.106 0 0 0-1.3-.5Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 2.5v3.8a1.367 1.367 0 0 0 1.4 1.4h3.9Z",
  fill: "#eaecef"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6 7.1 14.3.9 13.8 8c0 .4.3.7.8.8h6.8l-6-.9a.789.789 0 0 1-.8-.8Z",
  fill: "#e6e7e8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 20.1a.684.684 0 0 1-.7.7H1.3a.684.684 0 0 1-.7-.7v-7.6a.684.684 0 0 1 .7-.7h20.4a.684.684 0 0 1 .7.7Z",
  fill: "#692e7c"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 20.5a.684.684 0 0 1-.7.7H1.3a.684.684 0 0 1-.7-.7v-7.6a.684.684 0 0 1 .7-.7h20.4a.684.684 0 0 1 .7.7Z",
  fill: "#813d94"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1 25.6v-3.3H9.6v3.3H7.8l3.5 4.4 3.6-4.4Z",
  fill: "#813d94",
  stroke: "#fff",
  strokeWidth: 1.59
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  transform: "translate(4.656 19.055)",
  fill: "#fff",
  fontSize: 6.89,
  fontFamily: "Nunito Sans"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "PDF"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(4.656 19.055)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.132,
  fontSize: 6.89,
  fontFamily: "Nunito Sans"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "PDF"))));
export default SvgPdf;